import { useMemo } from "react";

import { useFeatureFlags } from "@hooks/http";
import {
  type AccountingMode,
  AccountingModes,
  type TimeGranularity,
} from "@north-beam/nb-common";

export function useShowV1Forecasts(
  timeGranularity: TimeGranularity,
  attributionModel: string,
  accountingMode: AccountingMode,
) {
  const { hasFeatureFlag } = useFeatureFlags();
  const showV1Forecasts = useMemo(() => {
    return (
      timeGranularity !== "hourly" &&
      attributionModel === "northbeam_custom" &&
      accountingMode === AccountingModes.ACCRUAL &&
      hasFeatureFlag("showV1Forecasts")
    );
  }, [accountingMode, attributionModel, hasFeatureFlag, timeGranularity]);

  return showV1Forecasts;
}
